module.exports = __webpack_public_path__ + "img/new-home-page-guide-drawer-illustration-en4.85cc1ac.png";